<template>
  <component :is="props.isClickable ? Link : 'span'" :decoration="decoration" :to="routeTo" @click.stop>
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Link } from '@tallo/design-system';
import { renterProfileRoute } from '@tallo/investor/navigation';

interface RenterProfileLinkProps {
  isClickable?: boolean;
  decoration?: boolean;
  propertyId: string;
  renterId: string;
}

const props = withDefaults(defineProps<RenterProfileLinkProps>(), {
  isClickable: true,
  decoration: true,
});

const routeTo = computed(() => renterProfileRoute(props.propertyId, props.renterId));
</script>
